 export const ALLOWED_ROLES = ['EXP31', 'EXP11', 'EXC32', 'ADM'];

export const INDIA_CENTER_LOCATION = { lat: 21.1458, lng: 79.0882 }

export const STATES = [
    // {
    //     value: "Select State",
    //     position: {}
    // },
    {
        value: 'ANDAMAN & NICOBAR',
        position: { lat: 28.6139, lng: 77.2088 }
    },
    {
        value: "ANDHRA PRADESH",
        position: { lat: 15.9129, lng: 79.7400 }
    },
    {
        "value": "ARUNACHAL PRADESH",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "ASSAM",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "BIHAR",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "CHANDIGARH",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "CHHATTISGARH",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "DADAR & NAGAR ",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "DAMAN & DIU",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "DELHI",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "GOA",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "GUJARAT",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "HARYANA",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "HIMACHAL PRADESH",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "JAMMU & KASHMIR",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "JHARKHAND",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "KARNATAKA",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "KERALA",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "LADAKH",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "MADHYA PRADESH",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "MAHARASHTRA",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "MANIPUR",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "MEGHALAYA",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "MIZORAM",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "NAGALAND",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "ODISHA",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "PUDUCHERRY",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "PUNJAB",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "RAJASTHAN",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "SIKKIM",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "TAMIL NADU",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "TELANGANA",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "TRIPURA",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "UNKNOWN",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "UTTAR PRADESH",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "UTTARAKHAND",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    },
    {
        "value": "WEST BENGAL",
        "position": {
            "lat": 28.6139,
            "lng": 77.2088
        }
    }
]

export const DISTRICTS = ["ADILABAD","AGRA","AJMER","ALIGARH","ALIPURDUAR","ALLAHABAD","ALWAR","AMBEDKAR NAGAR","AMETHI","AMETHI  CSM NAGAR","AMETHI - CSM NAGAR","AMRAVATI","ANANTAPUR","ANJAW","ANUGUL","ARAVALLI","AURANGABAD","AURANGABAD (BIHAR)","AZAMGARH","BAGESHWAR","BAGHPAT","BAHRAICH","BAJALI","BAKSA","BALAGHAT","BALLIA","BALODA BAZAR","BALODABAZAR","BALOTARA","BALRAMPUR","BANAS KANTHA","BANGALORE URBAN","BANKA","BANKURA","BANSWARA","BARAGARH","BARAMULA","BARAMULLA","BAREILLY","BARGARH","BARNALA","BARPETA","BARWANI","BASTAR","BASTI","BATHINDA","BELAGAVI","BELAGAVI CHIKKODI","BEMETARA","BENGALURU RURAL","BENGALURU U NORTH","BENGALURU U SOUTH","BHADOHI","BHADOI","BHAGALPUR","BHANDARA","BHARATPUR","BHARUCH","BHAVNAGAR","BHIND","BHOPAL","BIJNOR","BIJNOUR","BIRBHUM","BISWANATH","BOKARO","BOLANGIR","BOTAD","BOUDH","BULANDSHAHAR","BULDANA","CACHAR","CAPITAL COMPLEX ITANAGAR","CENTRAL DELHI","CHAMARAJA NAGAR","CHAMARAJANAGARA","CHAMOLI","CHAMPAWAT","CHANDAULI","CHANDIGARH","CHANGLANG","CHATRA","CHENNAI","CHHATARPUR","CHHATRAPATI SAMBHAJINAGAR","CHIKKABALLAPUR","CHIKKABALLAPURA","CHIRANG","CHITRAKOOT","CHITTOOR","CHOTA UDAIPUR","CHURACHANDPUR","CHURU","DAKSHIN DINAJPUR","DAMAN","DANTEWADA","DARJILING","DAUSA","DEHRADUN","DEOGARH","DEOGHAR","DEORIA","DHALAI","DHAMTARI","DHANBAD","DHAR","DHAULPUR","DIMA HASAO","DIMAPUR","DINDIGUL","DODA","DOHAD","DUMKA","DUNGARPUR","EAST","EAST GODAVARI","EAST NIMAR","EAST SIANG","ELURU","ERNAKULAM","ERODE","ETAH","FARIDABAD","FARRUKHABAD","FATEHABAD","FATEHGARH SAHIB","FATEHPUR","FAZILKA","FIROZABAD","FIROZPUR","GADCHIROLI","GANGTOK","GANJAM","GARHWA","GARIABAND","GAUTAM BUDDHA NAGAR","GHAZIPUR","GOALPARA","GOLAGHAT","GOMATI","GONDA","GORAKHPUR","GUMLA","GUNA","GURUGRAM","GWALIOR","HAMIRPUR (H.P.)","HAMIRPUR (U.P.)","HANUMAKONDA","HARDA","HAVERI","HAZARIBAG","HAZARIBAGH","HINGOLI","HISSAR","HNAHTHIAL","HOSHANGABAD","IMPHAL EAST","IMPHAL WEST","JABALPUR","JAGATSINGHPUR","JAGTIAL","JAISALMER","JALAUN","JAMMU","JAMUI","JANGAON","JANGOAN","JANJGIR  CHAMPA","JANJGIR - CHAMPA","JASHPUR","JAUNPUR","JAYASHANKAR","JEHANABAD","JHAJJAR","JHARGRAM","JOGULAMBA GADWAL","JORHAT","JYOTIBA PHULE NAGAR (AMROHA","KABEERDHAM","KABIRDHAM","KAIMUR","KAKCHING","KALABURAGI","KALIMPONG","KALLAKURICHI","KAMLE","KAMRUP METROPOLITAN","KAMRUP-METRO","KAMRUPRURAL","KANCHEEPURAM","KANDHAMAL","KANGRA","KANNAUJ","KANNIYAKUMARI","KANNUR","KANPUR DEHAT","KARAIKAL","KARAULI","KARGIL","KARIMNAGAR","KATIHAR","KAWARDHA","KENDRAPARA","KENDUJHAR","KHAGARIA","KHAMMAM","KHAWZAWL","KHERI","KINNAUR","KIPHIRE","KISHTWAR","KODARMA","KOHIMA","KOKRAJHAR","KOLAR","KOLASIB","KOLHAPUR","KOLLAM","KONDAGAON","KOTA","KRISHNAGIRI","KUMURAM BHEEM ASIFABAD","KUPWARA","KURNOOL","KURUKSHETRA","KUSHINAGAR","LAHUL & SPITI","LAKHIMPUR","LALITPUR","LATEHAR","LATUR","LAWNGTLAI","LEH (LADAKH)","LEPA RADA","LONGDING","LOWER SIANG","LOWER SUBANSIRI","LUCKNOW","LUDHIANA","LUNGLEI","MAHABUBABAD","MAHARAJGANJ","MAHE","MAHENDRAGARH","MAHISAGAR","MALERKOTLA","MAMIT","MANDSAUR","MANDYA","MANSA","MATHURA","MAU","MAYURBHANJ","MEDCHAL MALKAJGIRI","MIDDLE AND NORTHANDAMANS","MIRZAPUR","MOHALI","MOKOKCHUNG","MON","MUKTSAR","MULUGU","MUMBAI","MUNGELI","MUZAFFARPUR","NAGAPATTINAM","NAGPUR","NALANDA","NAMAKKAL","NAMCHI","NAMSAI","NANDED","NANDURBAR","NARAYANPUR","NARSIMHAPUR","NARSINGHPUR","NASHIK","NAVSARI","NEW DELHI","NICOBARS","NIZAMABAD","NORTH 24-PARGANA","NORTH DINAJPUR","NORTH EAST","NORTH SIKKIM","NORTH TRIPURA","NORTH TWENTY FOURPARGANA","NUAPADA","NUH","OSMANABAD","PALAMU","PALI","PALNADU","PANCH MAHALS","PANCHKULA","PANIPAT","PANNA","PAPUM PARE","PAPUMPARA","PASCHIM BARDHAMAN","PASCHIM MEDINIPUR","PASHCHIMI SINGHBHUM","PATHANKOT","PAURI","PERAMBALUR","PEREN","PHERZAWL","PILIBHIT","PONDICHERRY","PRATAPGARH","PUDUCHERRY","PULWAMA","PURBA CHAMPARAN","PURBA MEDINIPUR","PURI","RAICHUR","RAIGARH","RAIGARH (MAHARASHTRA)","RAIPUR","RAJANNA","RAJANNA SIRICILLA","RAJAURI","RAJGARH","RAJKOT","RAJNANDGAON","RAMGARH","RAMPUR","RANCHI","RANGA REDDY","RANIPET","REWA","REWARI","ROHTAK","ROHTAS","RUDRAPRAYAG","SABAR KANTHA","SAHARSA","SAHIBGANJ","SAITUAL","SALEM","SAMASTIPUR","SAMBALPUR","SAMBHAL","SAMBHAL (BHIM NAGAR)","SANGRUR","SARAIKELA-KHARSAWAN","SARAN","SATARA","SERCHHIP","SHAHJAHANPUR","SHEOPUR","SHI YOMI","SHOPIAN","SIBSAGAR","SIDDHARTH NAGAR","SIDDHARTHNAGAR","SIKAR","SINDHUDURG","SINGRAULI","SIROHI","SITAMARHI","SITAPUR","SOLAPUR","SONEPUR","SONITPUR","SOUTH","SOUTH DELHI","SOUTH GARO HILLS","SOUTH SIKKIM","SOUTH TWENTY FOUR PARGAN*","SOUTH WEST DELHI","SOUTH WEST GARO HILLS","SRIKAKULAM","SUNDARGARH","TAMULPUR","TAPI","TAWANG","TEHRI GARHWAL","TENGNOUPAL","THE NILGIRIS","THENI","THOOTHUKKUDI","THOOTHUKUDI","THRISSUR","TIKAMGARH","TIRUPATI","TIRUPATTUR","TIRUPPATTUR","TIRUPPUR","TIRUVALLUR","TIRUVANNAMALAI","TONK","TRICHIRAPPALLI","TUENSANG","TUMAKURU MADHUGIRI","UDALGURI","UNA","UNAKOTI","UNKNOWN","UNNAO","UTTAR DINAJPUR","UTTARA KANNADA","UTTARA KANNADA SIRSI","UTTARKASHI","VADODARA","VAISHALI (HAJIPUR)","VIDISHA","VILUPPURAM","VISAKHAPATANAM","VIZIANAGARAM","WANAPARTHY","WARANGAL RURAL","WARANGAL URBAN","WASHIM","WAYANAD","WEST GARO HILLS","WEST GODAVARI","WEST KAMENG","WEST KHASI HILLS","WEST SIKKIM","WOKHA","YADADRI BHUVANAGIRI","YADGIR","YAMUNANAGAR","YAVATMAL"]

export const SCHOOL_CATEGORY = [
    "1 - Primary",
    "2 - Primary with Upper Primary",
    "3 - Pr. with Up.Pr. sec. and H.Sec.",
    "4 - Upper Primary only ",
    "5 - Up. Pr. Secondary and Higher Sec",
    "6 - Pr. Up Pr. and Secondary Only",
    "7 - Upper Pr. and Secondary",
    "8 - Secondary Only",
    "10 - Secondary with Higher Secondary",
    "11 - Higher Secondary only/Jr. College",
]

export const HEX_CODES = ['#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000075', '#808080',   "#c9453a", "#EA4335"];

export const HEX_CODES_STAGE_CATEGORIES = ['#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231', "#EA4335"]

export const DEAL_STAGE_CATEGORIES = [
    'Meeting Pending', 'In Pipeline', 'Won', 'Lost', 'S2O Drop', 'Other'
]

export const DEAL_LABELS = [
    '1. Meeting Sales Prospects', '2. Appointment Set', '3. First Meeting Done', '4. Opportunity', '5. Active Lead', '6. Hot Lead','7. E-Quote Creation', '13. ONLY sign up amount pending','8. Announcement', '10. Errored Deals before Sign up', '11. Sent to Finance, PSV for Approval','12. Rejected by Finance/PSV', '14. Sign-Up', '15. Deal Revision for Finance Approval', '16. Deal Revision rejected by Finance','9. Month Drop', '17. Hold', '18. Closed-Lost', '19. Expired', '20. Dormant','21. S2O Drop',  "No Show"
]

export const AFFILIATION_DISE = ['1-CBSE', '2-State Board', '3-ICSE', '4-International Board', '5-Others'];

export const UNIVERSE_VIEW = [
    {
        label:'Tofu View',
        value: 'tofu'
    },
    {
        label:'Deal View',
        value: 'deal'
    }
];

// export const MORE_OPTIONS = [
//     'Relation With Lead', 'Relation With Pearson','Deal Stage Category', 'Affiliation Dise', 'School Category', 'Meeting Scheduled Date'
// ]

export const DIMENSIONS = [
    'Deal Stage Category', 'Deal Label', 
];

const RELATION_WITH_LEAD = ['Partnered School']
const RELATION_WITH_PEARSON = ['User School']

const USER_EMAILS = []
const INSIDESALES_EMAILS = []



export const INPUT_FIELDS = [{
    key: "o.email",
    label: "Select Area Manager ",
    name: "Email",
    type: "select",
    isSelected: true,
    visible: false,
    data: USER_EMAILS
},
{
    key: "p.insidesaleemail",
    label: "Select Inside Sales Owner",
    name: "InsideSale",
    type: "select",
    isSelected: true,
    visible: true,
    data:  INSIDESALES_EMAILS
},{
    key: "p.state",
    label: "Select State",
    name: "State",
    type: "select",
    isSelected: true,
    visible: true,
    data: STATES
},{
    key: "p.district",
    label: "Select District",
    name: "District",
    type: "select",
    isSelected: true,
    visible: true,
    data: DISTRICTS
},{
    key: "pin_code",
    label: "Enter Pincode",
    name: "Pincode",
    type: "text",
    isSelected: false,
    notADMview:true,
    visible: true,
    data: null
},{
    key: "stage_category",
    label: "Select Deal Stage Category",
    name: "Deal Stage Category",
    type: "select",
    isSelected: false,
    notADMview:true,
    visible: true,
    data: DEAL_STAGE_CATEGORIES
},
// {
//     key: "relationship_w_lead",
//     label: "Select Releation With Lead",
//     name: "Relation With Lead",
//     type: "select",
//     isSelected: false,
//     visible: true,
//     data: RELATION_WITH_LEAD
// },{
//     key: "relationship_w_pearson",
//     label: "Select Releation With Pearson",
//     name: "Relation With Pearson",
//     type: "select",
//     isSelected: false,
//     visible: true,
//     data: RELATION_WITH_PEARSON
// },
{
    key: "meeting_scheduled_date",
    label: "Enter Meeting Scheduled Date",
    name: "Meeting Scheduled Date",
    type: "date",
    isSelected: false,
    notADMview:true,
    visible: true,
    data: null
}
// {
//     key: "affiliation__dise",
//     label: "Select Affiliation Dise",
//     name: "Affiliation Dise",
//     type: "select",
//     isSelected: false,
//     visible: true,
//     data: AFFILIATION_DISE
// // },
// {
//     key: "school_category",
//     label: "Select School Category",
//     name: "School Category",
//     type: "select",
//     isSelected: false,
//     visible: true,
//     data: SCHOOL_CATEGORY
// }
];

export const INPUT_FIELDS_ADM = [{
    key: "p.state",
    label: "Select State",
    name: "State",
    type: "select",
    isSelected: true,
    visible: true,
    data: STATES
},
   {
    key: "p.district",
    label: "Select District",
    name: "District",
    type: "select",
    isSelected: true,
    visible: true,
    data: DISTRICTS
},{
    key: "pin_code",
    label: "Enter Pincode",
    name: "Pincode",
    type: "text",
    isSelected: true,
    
    visible: true,
    data: null
},{
    key: "stage_category",
    label: "Select Deal Stage Category",
    name: "Deal Stage Category",
    type: "select",
    isSelected: true,
   
    visible: true,
    data: DEAL_STAGE_CATEGORIES
},
// {
//     key: "relationship_w_lead",
//     label: "Select Releation With Lead",
//     name: "Relation With Lead",
//     type: "select",
//     isSelected: false,
//     visible: true,
//     data: RELATION_WITH_LEAD
// },{
//     key: "relationship_w_pearson",
//     label: "Select Releation With Pearson",
//     name: "Relation With Pearson",
//     type: "select",
//     isSelected: false,
//     visible: true,
//     data: RELATION_WITH_PEARSON
// },
{
    key: "meeting_scheduled_date",
    label: "Enter Meeting Scheduled Date",
    name: "Meeting Scheduled Date",
    type: "date",
    isSelected: true,
   
    visible: true,
    data: null
}
// {
//     key: "affiliation__dise",
//     label: "Select Affiliation Dise",
//     name: "Affiliation Dise",
//     type: "select",
//     isSelected: false,
//     visible: true,
//     data: AFFILIATION_DISE
// // },
// {
//     key: "school_category",
//     label: "Select School Category",
//     name: "School Category",
//     type: "select",
//     isSelected: false,
//     visible: true,
//     data: SCHOOL_CATEGORY
// }
];


